<template>
  <div class="not-full SectionReview">
    <div class="box notsun slow delay-500ms" v-inview:animate="'fadeInUp'">
      <carousel :autoplay="true"
                :loop="true"
                :per-page="1"
                :mouse-drag="true"
                :paginationActiveColor="'#1baaf1'"
                :paginationColor="'#d7e1ea'"
                :paginationSize="7"
                :paginationPadding="3.5">
        <slide :index="index" :key="index" v-for="(item, index) in list">
          <div class="title" v-html="item.title"></div>
          <div class="content" v-html="item.content"></div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionReview',
  components: {
  },
  props: {},
  data: function () {
    return {
      list: [
        {
          title: '서울, 삼겹살집 사장님',
          content: '<b>“</b> 펀다나우 마이너스 통장을 통해 매월 직원들 인건비, 재료비를 내고 있어요. 코로나로 인해 매출이 줄어들어 걱정했는데,<br> <b>펀다나우는 필요할 때 언제든지 쓸 수 있는 점이 가장 큰 장점이에요!</b> <b>”</b>'
        }, {
          title: '논현동, 치킨집 사장님',
          content: '<b>“</b> 펀다나우 이용하면서 급할 때마다 바로 재료비를 지급할 수 있어요. <b>”</b>'
        }, {
          title: '한남동, 노래방 사장님',
          content: '<b>“</b> 직원 월급을 지급날 돈이 갑자기 필요한 경우가 많은데, <b>펀다나우</b>로 하루 매출을 미리 받아 주고 있어요. <b>”</b>'
        }, {
          title: '역삼동, 카페 사장님',
          content: '<b>“</b> 코로나처럼 위기일 때 <b>펀다나우</b>로 비상금을 사용할 수 있어서 안심돼요! <b>”</b>'
        }
      ],
      currentSlide: 0,
      slickOptions: { slidesToShow: 1, arrows: false, autoplay: true, autoplaySpeed: 5000 },
    }
  },
  computed: {
  },
  async created() {
  },
  destroyed() {},
  methods: {
    handleAfterChange(event, slick, currentSlide) {
      this.currentSlide = currentSlide
    },
  },
}
</script>

<style lang="scss" scoped>
  .SectionReview {
    width: 100%;
    padding-top: 60px;
    padding-bottom: 60px;
    float: left;
    background-color: #f5f5f5;
    box-sizing: border-box;

    .box {
      width: 100%;
      border-radius: 6px;
      box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      padding: 27px 25px 23px 25px;
      box-sizing: border-box;

      .title {
        width: 100%;
        font-weight: 800;
        font-size: 17px;
        letter-spacing: -0.31px;
        text-align: center;
        color: #333333;
      }
      .content {
        width: 100%;
        font-weight: 500;
        font-size: 14px;
        line-height: 1.43;
        letter-spacing: 0.04px;
        text-align: center;
        color: #333333;
        margin-top: 18px;
      }
      .dots {
        width: 100%;
        margin-top: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        .dot {
          width: 7px;
          height: 7px;
          border-radius: 100%;
          background-color: #d7e1ea;
          margin-left: 3.5px;
          margin-right: 3.5px;
        }
      }
    }
  }
</style>
